import {Color, FrontSide, ShaderMaterial, Texture, Vector2} from "three";
import panoramaVertex from "features/apartmentViewer/ApartmentViewer/shaders/panoramaMaterial/panoramaVertex.glsl";
import panoramaFragment from "features/apartmentViewer/ApartmentViewer/shaders/panoramaMaterial/panoramaFragment.glsl";

export class PanoramaMaterialFactory {
    public static createMaterial(texture: Texture | null, color: Color = new Color(1, 1, 1), repeat: Vector2 = new Vector2(1,1), depthOffset: number = 0) : ShaderMaterial {
        return new ShaderMaterial({
            uniforms: {
                map: { value: texture },
                color: { value: color },
                repeat: { value: repeat },
                depthOffset: { value: depthOffset }
            },
            vertexShader: panoramaVertex,
            fragmentShader: panoramaFragment,
            side: FrontSide,
        })
    }
}
